import type { SupSingleVaultV3 } from "@/types";
import React from "react";

import UiLabelPlaceholder from "@/components/Ui/Label/Placeholder";
import { SupTracker } from "@repo/core-ui";

interface GridCellYieldTypeProps {
  vault: SupSingleVaultV3;
}

export default function GridCellYieldType({ vault }: GridCellYieldTypeProps) {
  const hasYieldType = vault.yield_type !== "";
  const beatifiedYieldType = hasYieldType ? vault.yield_type?.replace(/_/g, " ") : "";

  return hasYieldType ? (
    <SupTracker variant="primary-active" className="min-h-[20px] border-0.5 border-neutral-300 bg-neutral p-1 text-[12px]">
      {beatifiedYieldType}
    </SupTracker>
  ) : (
    <UiLabelPlaceholder>N/A</UiLabelPlaceholder>
  );
}
